import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import Navbar from '../components/Navbar';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';
import api from '../utils/api';

export default function EmailVerification() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    
    if (!token) {
      setStatus('error');
      setMessage('Invalid verification link');
      return;
    }

    verifyEmail(token);
  }, [searchParams]);

  const verifyEmail = async (token) => {
    try {
      await api.post(`/auth/verify-email?token=${token}`);
      setStatus('success');
      setMessage('Your email has been verified successfully!');
      toast.success('Email verified! You can now log in.');
    } catch (error) {
      setStatus('error');
      setMessage(error.response?.data?.detail || 'Verification failed. The link may be invalid or expired.');
      toast.error('Verification failed');
    }
  };

  return (
    <div className="min-h-screen noise-bg">
      <Navbar />
      
      <div className="pt-32 pb-12">
        <div className="max-w-md mx-auto px-4">
          <div className="bg-[#0A0A0A] border border-border rounded-lg p-8 text-center">
            {status === 'verifying' && (
              <>
                <Loader2 className="w-16 h-16 mx-auto mb-6 text-[#00E055] animate-spin" />
                <h1 className="text-2xl font-bold mb-4" style={{fontFamily: 'Unbounded, sans-serif'}}>
                  VERIFYING EMAIL...
                </h1>
                <p className="text-muted-foreground">Please wait while we verify your email address.</p>
              </>
            )}

            {status === 'success' && (
              <>
                <CheckCircle className="w-16 h-16 mx-auto mb-6 text-green-400" />
                <h1 className="text-2xl font-bold mb-4 text-green-400" style={{fontFamily: 'Unbounded, sans-serif'}}>
                  EMAIL VERIFIED!
                </h1>
                <p className="text-muted-foreground mb-6">{message}</p>
                <Button
                  onClick={() => navigate('/login')}
                  className="bg-[#00E055] hover:bg-[#00E055]/90 text-black font-bold w-full"
                >
                  GO TO LOGIN
                </Button>
              </>
            )}

            {status === 'error' && (
              <>
                <XCircle className="w-16 h-16 mx-auto mb-6 text-red-400" />
                <h1 className="text-2xl font-bold mb-4 text-red-400" style={{fontFamily: 'Unbounded, sans-serif'}}>
                  VERIFICATION FAILED
                </h1>
                <p className="text-muted-foreground mb-6">{message}</p>
                <div className="space-y-3">
                  <Button
                    onClick={() => navigate('/login')}
                    className="bg-[#00E055] hover:bg-[#00E055]/90 text-black font-bold w-full"
                  >
                    GO TO LOGIN
                  </Button>
                  <Button
                    onClick={() => navigate('/register')}
                    variant="outline"
                    className="w-full"
                  >
                    REGISTER AGAIN
                  </Button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
